import { Injectable } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { Pos } from '@shop/const';
import { StateUtils } from '@spartacus/core';
import { Observable } from 'rxjs';
import { CheckoutActions } from '../store/actions';
import { StateWithCustomCheckout } from '../store/checkout-state';
import { CheckoutSelectors } from '../store/selectors';

@Injectable({
  providedIn: 'root',
})
export class UserPickupShopsFacade {
  constructor(private store: Store<StateWithCustomCheckout>) {}

  getListState(): Observable<StateUtils.LoaderState<Pos[]>> {
    return this.store.pipe(select(CheckoutSelectors.getUserPickupShopListState));
  }

  getList(): Observable<Pos[] | undefined> {
    return this.store.pipe(select(CheckoutSelectors.getUserPickupShopListValue));
  }

  getListLoading(): Observable<boolean> {
    return this.store.pipe(select(CheckoutSelectors.getUserPickupShopListLoading));
  }

  getListSuccess(): Observable<boolean> {
    return this.store.pipe(select(CheckoutSelectors.getUserPickupShopListSuccess));
  }

  getListError(): Observable<boolean> {
    return this.store.pipe(select(CheckoutSelectors.getUserPickupShopListError));
  }

  add(shopName: string): void {
    this.store.dispatch(new CheckoutActions.AddUserPickupShop({ shopName }));
  }

  remove(shopName: string): void {
    this.store.dispatch(new CheckoutActions.RemoveUserPickupShop({ shopName }));
  }
}
